import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchFile } from "./use-file";

export function useDowloadFile() {
  const queryClient = useQueryClient();

  const { token } = queryClient.getDefaultOptions().queries?.meta ?? {};

  const { mutate, ...mutation } = useMutation({
    mutationFn: (params: { id: string; fileName: string }) =>
      downloadFile(params.id, params.fileName, token!),
  });

  return {
    downloadFile: mutate,
    ...mutation,
  };
}

async function downloadFile(id: string, fileName: string, token: string) {
  const url = await fetchFile(id, token);

  const anchorElement = document.createElement("a");

  anchorElement.href = url;
  anchorElement.download = fileName;
  anchorElement.style.display = "none";

  document.body.appendChild(anchorElement);

  anchorElement.click();
  anchorElement.remove();

  window.URL.revokeObjectURL(url);
}
